import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button, Modal, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { saveSignature } from '../../services/apifp';  // ✅ เรียกใช้ API ที่แยกไว้

const SignatureCD = () => {
    const [showSignatureModal, setShowSignatureModal] = useState(false);
    const [signature, setSignature] = useState(null);
    const signRef = useRef({});

    // เปิด Modal
    const handleShowSignatureModal = () => setShowSignatureModal(true);

    // ปิด Modal
    const handleCloseSignatureModal = () => setShowSignatureModal(false);

    // บันทึกลายเซ็น
    const handleGenerateSignature = () => {
            // if (signRef.current.isEmpty()) {
            //     toast.warning("❌ กรุณาลงลายเซ็นก่อนกดบันทึก");
            //     return;
            // }
        setSignature(signRef.current.getTrimmedCanvas().toDataURL("image/png"));
        handleCloseSignatureModal();
        
    };

    // ล้างลายเซ็น
    const handleClearSignature = () => {
        signRef.current.clear();
    };

    const handleSaveData = async () => {
        if (!signature) {
            toast.error("❌ กรุณาลงลายเซ็นก่อนบันทึกข้อมูล");
            return;
        }

        const response = await saveSignature(signature); // ✅ ใช้ API จาก `apifp.js`
        console.log("📝 Sending Signature Data:", { signature });
    
        if (response) {
            console.log("📝 บันทึกลายเซ็นสำเร็จ:", response);
            toast.success("✅ บันทึกลายเซ็นสำเร็จ!");
            setSignature(null);
        }
    };

    return (

        <div className="row ">
            {/* การรับรู้และลายเซ็น */}
            <div className="col-md-6 col-12 m-0">
                <Card className="m-0 col-md-12">
                    <Card.Header>เพิ่มลายเซ็นของฉัน</Card.Header>
                    <Card.Body>
                        <div
                            id="signature-area"
                            className="mt-3 position-relative"
                            style={{
                                width: '100%',
                                height: '150px',
                                border: '1px solid gray',
                                backgroundColor: 'white',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                // justifyContent: 'center',
                            }}
                        >
                            {/* ปุ่ม "ลงนาม" */}
                            <button
                                className="btn btn-secondary"
                                type="button"
                                onClick={handleShowSignatureModal}
                                style={{ zIndex: 1 }}
                            >
                                <i className="fa fa-pencil"></i> ลงนาม
                            </button>

                            {/* แสดงภาพลายเซ็นเมื่อมีการเซ็นแล้ว */}
                            {signature && (
                                <img
                                    src={signature} // แสดงลายเซ็นคนที่สอง
                                    alt="ลายเซ็น"
                                    style={{
                                        maxWidth: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                        maxHeight: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                        display: signature ? 'block' : 'none', // ซ่อนหากยังไม่มีลายเซ็น
                                    }}
                                />
                            )}
                        </div>
                        <div>
                            <Button
                                className="mt-3"
                                variant="primary"
                                onClick={handleSaveData}
                            >
                                บันทึกข้อมูล
                            </Button>
                        </div>
                    </Card.Body>
                </Card>

                {/* Modal สำหรับลงลายเซ็น */}
                <Modal show={showSignatureModal} onHide={handleCloseSignatureModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>เพิ่มลายเซ็นของฉัน</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div
                            className="col-12"
                            style={{
                                border: "2px solid black",
                                width: "100%",
                                height: 200,
                            }}
                        >
                            <SignatureCanvas
                                canvasProps={{
                                    width: 500,
                                    height: 200,
                                    className: "sigCanvas",
                                }}
                                ref={signRef}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={handleGenerateSignature}>
                            ใช้ลายเซ็นนี้
                        </Button>
                        <Button variant="warning" onClick={handleClearSignature}>
                            เซ็นใหม่
                        </Button>
                    </Modal.Footer>
                </Modal>

            </div>
        </div>

    );
};

export default SignatureCD;
